import { Checkbox } from 'cpool-components/input/Checkbox';
import { useTranslation } from 'react-i18next';

import { cn } from '~/utils/cnTailwind';

type Props = {
    className?: string;
    content: string;
    id: string;
    isEnabled: boolean;
    onContentChange: (content: string) => void;
    onToggle: (checked: boolean) => void;
};

export const AddNoteCard: React.FC<Props> = ({ className, content, id, isEnabled, onContentChange, onToggle }) => {
    const { t } = useTranslation();

    return (
        <div className={cn('p-[18px] bg-white border rounded-lg border-grey-stroke', className)}>
            <Checkbox
                id={id}
                label={t('STATUS.ADD_NOTE')}
                checked={isEnabled}
                onChange={(event) => onToggle(event.target.checked)}
            />
            {isEnabled && (
                <textarea
                    className="mt-3 w-full p-3 text-sm bg-white border border-grey-stroke rounded resize-y min-h-[80px] focus:outline-none focus:ring-1 focus:ring-blue-focus focus:border-blue-focus"
                    placeholder={t('STATUS.NOTE_PLACEHOLDER')}
                    value={content}
                    onChange={(event) => onContentChange(event.target.value)}
                />
            )}
        </div>
    );
};
